/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Enterprise_RetrievalInputs */



/**
* | output |
* | --- |
* | "1 GB storage per user with encrypted data storage" |
*
* @param {Pricing_Feature_Enterprise_RetrievalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_enterprise_retrieval = /** @type {((inputs?: Pricing_Feature_Enterprise_RetrievalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Enterprise_RetrievalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 GB Speicher pro Nutzer mit verschlüsselter Datenspeicherung")
	return /** @type {LocalizedString} */ ("1 GB storage per user with encrypted data storage")
});